var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOmomi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.06506,45.21371c-1.30555-.09205-1.05557-1.337-.79683-2.31531l2.18766-8.2717a3.71,3.71,0,0,0-7.16848-1.91557c-.31941,1.18289-2.87548,11.73194-2.89122,11.798-.35746,1.49874-.785,3.41434-.12595,4.89163.99978,2.24084,4.03621,1.59,5.881,1.05659a14.70565,14.70565,0,0,0,3.60614-1.57516A33.08517,33.08517,0,0,0,70.42974,45.976l-.24483-2.46043A7.20407,7.20407,0,0,1,66.06506,45.21371Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.946,16.38279a5.54967,5.54967,0,0,0-5.59192,5.13244,4.22812,4.22812,0,0,0,.62391,2.38455c1.70725,2.76242,5.62946,2.16083,7.7499.25421C72.52659,21.63751,70.65219,16.61511,66.946,16.38279Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.00022,2.82615a30.84871,30.84871,0,1,0,30.8485,30.8485A30.88352,30.88352,0,0,0,64.00022,2.82615Zm0,55.07085A24.22214,24.22214,0,1,1,88.22214,33.67465,24.2498,24.2498,0,0,1,64.00022,57.897Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.349,87.36254c-10.92384-5.44557-34.89811-13.493-34.89811-13.493H75.42268l-6.56,8.75213,6.15031,42.55213h45.82186s-.33188-18.42629-2.20441-29.35012A11.66738,11.66738,0,0,0,112.349,87.36254Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.54909,73.86959S26.57482,81.917,15.651,87.36254a11.66738,11.66738,0,0,0-6.28138,8.46118c-1.87248,10.92384-2.20441,29.35012-2.20441,29.35012h45.8219l6.15031-42.55213-6.56-8.75213Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmomi);
export default __webpack_public_path__ + "static/media/omomi.f11d445e.svg";
export { ForwardRef as ReactComponent };